import { localizationService } from 'core/services';
import { isObservableArray } from 'mobx';
import _ from 'lodash';

const translate = message => {
	if (isObservableArray(message) || _.isArray(message)) {
		let messageVar = {};
		_.each(message[1], (val, key) => {
			messageVar[key] = localizationService.t(val);
		});
		return localizationService.t(message[0], messageVar);
	}
	return localizationService.t(message);
};

export default translate;



// WEBPACK FOOTER //
// ./src/core/utils/translate.js